export const FREE_CONVERSATION_LANGUAGES = ['es', 'en', 'no'];

export const DEFAULT_FREE_CONVERSATION_LANGUAGE = 'es';

export function normalizeFreeConversationLanguage(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return FREE_CONVERSATION_LANGUAGES.includes(normalized)
    ? normalized
    : DEFAULT_FREE_CONVERSATION_LANGUAGE;
}

export function isFreeConversationLanguage(value) {
  return FREE_CONVERSATION_LANGUAGES.includes(String(value || '').trim().toLowerCase());
}

export const FREE_CONVERSATION_COPY = {
  es: {
    documentTitle: 'Aprendos - Clases de conversación en vivo',
    loadingEpisodes: 'Cargando episodios...',
    loadingEpisode: 'Cargando episodio...',
    loadError: 'No se pudieron cargar los episodios.',
    notFound: 'Este episodio no está disponible.',
    backToEpisodes: 'Volver a episodios',
    kicker: 'Clases de conversación en vivo',
    heroTitleStart: 'Temas interesantes',
    heroTitleMiddle: 'para',
    heroTitleAccent: 'discutir juntos.',
    heroSubtitleLead: 'Experimenta en vivo la metodología de Aprendos.',
    heroSubtitleRest: 'Clases temáticas, entretenidas e interesantes a partir de un podcast para poder conversar, aprender vocabulario y practicar de manera natural y amena.',
    featured: 'Destacado',
    listenNow: 'Escuchar ahora',
    upcoming: 'Próximos episodios',
    empty: 'No hay episodios disponibles para este idioma.',
    beforeListening: 'Antes de escuchar',
    beforeInstruction: 'Reflexiona sobre estas preguntas para discutir en la clase.',
    nowPlaying: 'Reproduciendo',
    paused: 'En pausa',
    episode: 'Episodio',
    showTranscript: 'Ver transcripción',
    hideTranscript: 'Ocultar transcripción',
    transcriptLock: 'Escucha al menos una vez sin leer la transcripción para mejorar tu comprensión auditiva.',
    transcript: 'Transcripción',
    afterListening: 'Después de escuchar',
    afterInstruction: 'Decide si estas afirmaciones son verdaderas o falsas de acuerdo al episodio.',
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    correct: 'Correcto',
    incorrect: 'Incorrecto',
    duration: 'Duración',
    language: 'Idioma',
    promoTitle: '¿Te gustaría seguir aprendiendo?',
    promoCopy: 'Aprendos tiene episodios completos, ejercicios interactivos, biblioteca y práctica de conversación con tutores de IA. Pruébalo gratis.',
    promoCta: 'Únete a Aprendos',
  },
  en: {
    documentTitle: 'Aprendos - Live English conversation classes',
    loadingEpisodes: 'Loading episodes...',
    loadingEpisode: 'Loading episode...',
    loadError: 'We could not load the episodes.',
    notFound: 'This episode is not available.',
    backToEpisodes: 'Back to episodes',
    kicker: 'Live English conversation classes',
    heroTitleStart: 'Interesting topics',
    heroTitleMiddle: 'to',
    heroTitleAccent: 'discuss together.',
    heroSubtitleLead: 'Experience the Aprendos methodology live.',
    heroSubtitleRest: 'Thematic, engaging classes built around a podcast so you can discuss ideas, learn vocabulary, and practise naturally.',
    featured: 'Featured',
    listenNow: 'Listen now',
    upcoming: 'Upcoming episodes',
    empty: 'No episodes are available for this language yet.',
    beforeListening: 'Before listening',
    beforeInstruction: 'Think about these questions so you are ready to discuss them in class.',
    nowPlaying: 'Playing',
    paused: 'Paused',
    episode: 'Episode',
    showTranscript: 'Show transcript',
    hideTranscript: 'Hide transcript',
    transcriptLock: 'Listen at least once without reading the transcript to improve your listening comprehension.',
    transcript: 'Transcript',
    afterListening: 'After listening',
    afterInstruction: 'Decide whether these statements are true or false according to the episode.',
    trueLabel: 'True',
    falseLabel: 'False',
    correct: 'Correct',
    incorrect: 'Incorrect',
    duration: 'Duration',
    language: 'Language',
    promoTitle: 'Would you like to keep learning?',
    promoCopy: 'Aprendos has full episodes, interactive exercises, a library, and conversation practice with AI coaches. Try it for free.',
    promoCta: 'Join Aprendos',
  },
  no: {
    documentTitle: 'Aprendos - Gratis samtaletimer',
    loadingEpisodes: 'Laster episoder...',
    loadingEpisode: 'Laster episode...',
    loadError: 'Vi kunne ikke laste episodene.',
    notFound: 'Denne episoden er ikke tilgjengelig.',
    backToEpisodes: 'Tilbake til episoder',
    kicker: 'Gratis samtaletimer',
    heroTitleStart: 'Interessante temaer',
    heroTitleMiddle: 'å',
    heroTitleAccent: 'diskutere sammen.',
    heroSubtitleLead: 'Opplev Aprendos-metoden i praksis.',
    heroSubtitleRest: 'Tematiske og engasjerende timer bygget rundt en podkast, slik at du kan diskutere, lære ordforråd og øve naturlig.',
    featured: 'Fremhevet',
    listenNow: 'Lytt nå',
    upcoming: 'Kommende episoder',
    empty: 'Ingen episoder er tilgjengelige for dette språket ennå.',
    beforeListening: 'Før du lytter',
    beforeInstruction: 'Tenk gjennom disse spørsmålene før samtaletimen.',
    nowPlaying: 'Spiller',
    paused: 'Pause',
    episode: 'Episode',
    showTranscript: 'Vis transkripsjon',
    hideTranscript: 'Skjul transkripsjon',
    transcriptLock: 'Lytt minst én gang uten å lese transkripsjonen for å styrke lytteforståelsen.',
    transcript: 'Transkripsjon',
    afterListening: 'Etter lytting',
    afterInstruction: 'Avgjør om disse påstandene er sanne eller usanne ifølge episoden.',
    trueLabel: 'Sant',
    falseLabel: 'Usant',
    correct: 'Riktig',
    incorrect: 'Feil',
    duration: 'Varighet',
    language: 'Språk',
    promoTitle: 'Vil du fortsette å lære?',
    promoCopy: 'Aprendos har komplette episoder, interaktive øvelser, bibliotek og samtaleøving med AI-coacher. Prøv gratis.',
    promoCta: 'Bli med i Aprendos',
  },
};

export const LANGUAGE_LABELS = {
  es: 'Español',
  en: 'English',
  no: 'Norsk',
};

export const LANGUAGE_FLAGS = {
  es: 'https://flagcdn.com/w20/es.png',
  en: 'https://flagcdn.com/w20/gb.png',
  no: 'https://flagcdn.com/w20/no.png',
};
